import Vue from 'vue'
import Minidelivery from './Minidelivery.vue'
//import ModalError from './components/ModalError'
import Swal from 'sweetalert2/dist/sweetalert2.all.min.js'

Vue.config.productionTip = false
Vue.prototype.$raise = function(text, afterclose = undefined){
  Swal.fire({
    title: 'Ошибка!',
    text: text,
    allowOutsideClick: false,
    icon: 'error',
    confirmButtonText: 'Ok'
  })
    .then(() => {
      if (afterclose) {
        afterclose()
      }
    })
}

Vue.prototype.$popup = function(content) {
  Swal.fire({
    html: content,
    confirmButtonText: 'Ok'
  })
}


new Vue({
  render: h => h(Minidelivery)
}).$mount('#minidelivery')